import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ComplaintNatureCrudLayer from "../components/ComplaintNatureCrudLayer";

const ComplaintNaturePage = () => {
  return (
    <>
      <MasterLayout>
        <ComplaintNatureCrudLayer />
      </MasterLayout>
    </>
  );
};

export default ComplaintNaturePage;
